import React from "react";
import Modal from "../modal/Modal";
import HelpContent from "./HelpContent";

// In-game help: a dimmed modal over the match (GameLayout). The shell shows the
// same HelpContent inside a floating section modal at /help.
export default function HelpModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal
      title="How to play"
      onClose={onClose}
      footer={<button className="app-btn app-btn-primary" onClick={onClose}>Got it</button>}
    >
      <HelpContent />
    </Modal>
  );
}
